import React, { useState, useRef } from 'react'
import ProgressBar from './Progressbar';

function UploadForm() {

    const [type, setType] = useState("gallery")
    const [file, setFile] = useState(null);
    const [error, setError] = useState("");
    const imageRef = useRef(null);

    const types = ['image/png', 'image/jpeg'];

    const changeHandler = (e) => {

        let selected = e.target.files[0];
        if (selected && types.includes(selected.type)) {
            setFile(selected);
        } else {
            setFile(null);
            setError("Ugyldig fil valgt, velg jpg eller png")
        }

    }

    return (
        <form>
            <input hidden type="file" onChange={changeHandler} ref={imageRef} /><br />
            <div className="text-center"  onClick={() => imageRef.current.click()}><i className="fas fa-plus fa-3x"></i></div>
           
            <div className="output">
                {error && <div className="error">{error}</div>}
                { file && <div>{ file.name }</div>}
                { file && <ProgressBar type={type} file={file} setFile={setFile} /> }
            </div>
        </form>
    )
}
export default UploadForm